import React from "react";
import { Flex } from "rebass/styled-components";
import { Body } from "../Text";
import styled from "styled-components";
import { RiCloseLine } from "react-icons/ri";
import { Link } from "../Button";

export function NoticeBanner({
  className,
  children,
  backgroundColor,
  display,
  setShouldShow,
  onClick,
  hash,
  href,
  persistDismissal = true,
}: any) {
  return (
    <>
      <Banner
        className={className}
        display={display}
        backgroundColor={backgroundColor}
        onClick={onClick}
        href={href}
      >
        <BannerSpacer aria-hidden="true" />
        <StyledBody>{children}</StyledBody>
        <StyledClose
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShouldShow(false);
            // persistDismissal=false leaves persistence to the parent (e.g. a
            // banner that should return next session instead of staying closed)
            if (persistDismissal)
              localStorage.setItem(
                `banner-announcement-${hash}-has-been-closed`,
                "true",
              );
          }}
        />
      </Banner>
    </>
  );
}

const BannerSpacer = styled.div`
  margin-left: 5px;
  min-width: 24px;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    display: none;
  }
`;

const StyledClose = styled(RiCloseLine)`
  color: ${(props) => props.theme.colors.ice};
  margin-right: 5px;
  min-height: 24px;
  min-width: 24px;
  position: relative;
  z-index: 1;

  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.iceAlpha60};
  }

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    margin-right: 2px;
    margin-left: 5px;
  }
`;

const StyledBody = styled(Body)`
  font-weight: 500;
  position: relative;
  z-index: 1;
`;

const Banner = styled(Flex)`
  background: ${(props) =>
    props.backgroundColor
      ? props.backgroundColor
      : props.theme.colors.saleGradient};

  align-items: center;
  box-shadow: 0px 0px 15px rgba(12, 10, 24, 0.25);
  display: ${(props) => props.display};
  justify-content: space-between;
  overflow: hidden;
  padding: ${(props) => props.theme.space[3]}px;
  position: relative;
  width: 100%;
  z-index: 100;

  &::before {
    background: ${(props) => props.theme.colors.midnight};
    content: "";
    inset: 0;
    opacity: 0.1;
    pointer-events: none;
    position: absolute;
  }

  &:hover {
    cursor: pointer;
  }
`;
